// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__ckvw9","detailsBorder":"styles_detailsBorder__12yIR"};